import { toast } from '@/components/toast';
import { generateTranslationGroup } from '@/services/api';
import { logger } from '@/services/logger';
import { ITranslationGroup } from '@d-id/types';
import { useMutation, useQueryClient } from 'react-query';
import { GET_TRANSLATION_GROUPS_KEY } from './translationLibrary';

type GenerateTranslationGroupRequest = Pick<ITranslationGroup, 'id'>;

export const useGenerateTranslationGroup = () => {
    const queryClient = useQueryClient();

    return useMutation(
        async ({ id }: GenerateTranslationGroupRequest) => {
            return generateTranslationGroup(id);
        },
        {
            onError: (err: any) => {
                logger.error(`Could not generate translation group`, { err });
                toast.error({ title: `Could not generate translation group`, toastId: `library-item-generate-error` });
            },
            onSuccess: async () => {
                await queryClient.invalidateQueries(GET_TRANSLATION_GROUPS_KEY);
            },
        }
    );
};
